import { useTranslator } from "@eo-locale/react";

import { useEffect, useState } from "react";

import SelectFilter from "./select-filter";
import { getProjectTags } from "@/lib";
import type { Projects } from "@/types";

import { useAppSelector } from "@/redux/store/hooks";

const TagsFilter = ({ projects }: Projects): JSX.Element => {
  const { translate } = useTranslator();
  const { finder } = useAppSelector((state) => state.projects);
  const [selection, setSelection] = useState({});
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { filterByTag, locales } = queryFilter;

  useEffect((): void => {
    setSelection(finder.platformAnalyticsTagList);
  }, [finder]);

  const selectedValue =
    selection !== null ? { value: selection, label: selection[0] } : null;

  let tags = getProjectTags(projects);

  // remove item from tags if pre-filter q[platformAnalyticsTagList] is used
  if (filterByTag)
    tags = tags.filter(
      (tag) => tag.toLowerCase() !== filterByTag.toLowerCase()
    );

  const tagsList = tags.map((tag) => {
    return {
      value: tag,
      label: tag
    };
  });

  return (
    <SelectFilter
      type="tag"
      options={tagsList}
      selectedValue={selectedValue}
      label={
        locales["projects.tags.all"] || translate("projectFinder.tags.all")
      }
      boxClass="ehq-projectsTagsFilterContainer"
    />
  );
};

export default TagsFilter;
